"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var PlaylistWindowManagerState = /** @class */ (function () {
    function PlaylistWindowManagerState(options) {
        this.options = options;
        this.presentations = {};
        this.applicationVersions = {};
        this.themes = {};
        this.presentations = __assign({}, options.presentations);
        this.applicationVersions = __assign({}, options.applicationVersions);
        this.themes = __assign({}, options.themes);
        this.publishedAt = options.publishedAt;
    }
    PlaylistWindowManagerState.prototype.getPresentation = function (presentationId) {
        var presentation = this.options.presentations[presentationId];
        if (!presentation) {
            throw new Error("Failed to create window, missing presentation for '".concat(presentationId, "'"));
        }
        return presentation;
    };
    PlaylistWindowManagerState.prototype.setPresentation = function (presentation) {
        this.presentations[presentation.id] = presentation;
    };
    PlaylistWindowManagerState.prototype.getApplicationVersion = function (applicationVersionId) {
        var applicationVersion = this.options.applicationVersions[applicationVersionId];
        if (!applicationVersion) {
            throw new Error("Failed to create window, missing application version for ".concat(applicationVersionId));
        }
        return applicationVersion;
    };
    PlaylistWindowManagerState.prototype.setApplicationVersion = function (applicationVersion) {
        this.applicationVersions[applicationVersion.id] = applicationVersion;
    };
    PlaylistWindowManagerState.prototype.getTheme = function (themeId) {
        var theme = this.options.themes[themeId];
        if (!theme) {
            throw new Error("Failed to create window, missing theme for '".concat(themeId, "'"));
        }
        return theme;
    };
    PlaylistWindowManagerState.prototype.setTheme = function (theme) {
        this.themes[theme.id] = theme;
    };
    PlaylistWindowManagerState.prototype.getPublishedAt = function () {
        return this.publishedAt;
    };
    return PlaylistWindowManagerState;
}());
exports.default = PlaylistWindowManagerState;
